module.exports = __webpack_public_path__ + "static/sport/register-success-new.bfa1b0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/register-success-new.png
// module id = X6H5
// module chunks = 0